/* --------------------
 * react-lazy-data module
 * Constants
 * ------------------*/

// Exports

export const IS_RESOURCE = '__react-lazy-data.IS_RESOURCE';
export const DEFAULT_CACHE_VAR = '__react-lazy-data.DATA_CACHE';
